import React from 'react';

const Feature = ({ iconPath, name, description }) => (
  <div className="home__feature">
    <div>
      <img alt={name} className="home__feature__image"
        src={iconPath} />
    </div>
    <div className="home__feature__content">
      <div className="home__feature__name">{name}</div>
      <div className="home__feature__description">{description}</div>
    </div>
  </div>
);

export default Feature;



// WEBPACK FOOTER //
// ./src/modules/home/components/feature.js